export const FULFILLED = 'fulfilled';
export const UNINITIALIZED = 'uninitialized';
export const PENDING = 'pending';
export const REJECTED = 'rejected';